export function paymentElementOptions(extra = {}) {
  return {
    ...extra,
    wallets: { ...(extra.wallets || {}), link: 'never' },
  };
}
